export var ZendeskFieldIds = {
  PLATFORM: 31787848,
  CATEGORY: 360007663354
};